import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { EVENT } from '@/constant/event';
import EventBus from '@/utils/event-bus';
import { Refresh as IconRefresh } from '@icon-park/vue-next';
export default /*@__PURE__*/_defineComponent({
  __name: 'Refresh',
  setup: function setup(__props) {
    function refresh() {
      EventBus.emit(EVENT.REFRESH_ACTIVE_VIEW);
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(_unref(IconRefresh), {
        theme: "outline",
        size: "20",
        fill: "#666666",
        onClick: refresh
      });
    };
  }
});